import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DashboardNavBar from './DashboardNavBar';


export default function VenueDashboardWifiPage() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { t } = useTranslation();

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div style={{
        height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 16px', position: 'sticky', top: 0, zIndex: 100,
        background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 50%, #fbbf24 100%)',
      }}>
        <button onClick={() => navigate(`/venue-dashboard/${slug}`)} style={{
          background: 'rgba(255,255,255,0.2)', border: 'none', borderRadius: 8,
          color: 'white', fontSize: 20, width: 36, height: 36, cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>←</button>
        <span style={{ color: 'white', fontWeight: 700, fontSize: 17 }}>{t('vd.wifiLab')}</span>
        <div style={{ width: 36 }} />
      </div>

      {/* Coming soon */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', padding: 32, textAlign: 'center',
      }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>📶</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#111827', marginBottom: 8 }}>
          {t('vd.wifiLab')}
        </div>
        <div style={{ fontSize: 15, color: '#6b7280', maxWidth: 280, lineHeight: 1.5 }}>
          {t('vd.wifiLabDesc')}
        </div>
        <div style={{
          marginTop: 24, padding: '8px 20px', background: '#fef3c7',
          borderRadius: 20, fontSize: 13, color: '#92400e', fontWeight: 600,
        }}>
          {t('vd.comingSoon')}
        </div>
      </div>
      <DashboardNavBar />
    </div>
  );
}
